export default "__VITE_ASSET__BcNlNtfi__"